export default __webpack_public_path__ + "static/media/IconDesc_QuartzCrystal.256.78e65dfd.png";